import Vue from 'vue'
import * as OpenCC from 'opencc-js'
import { normalizeLanguage, readLanguage } from '@/utils/locale'
import pcMessages from './pc-messages'

const sourceContext = require.context('../locales/app/zh', false, /\.json$/)
const hkContext = require.context('../locales/app/zh-hk', false, /\.json$/)
const enContext = require.context('../locales/app/en', false, /\.json$/)
const koContext = require.context('../locales/app/kn', false, /\.json$/)

const TARGET_CONTEXTS = {
  'zh-HK': hkContext,
  en: enContext,
  ko: koContext
}

const PC_OVERRIDES = {
  'zh-HK': {
    '总览': '總覽',
    '机器人': '機器人',
    '收益': '收益',
    '资产': '資產',
    '资金、燃料与点卡账户集中管理': '資金、燃料與點卡帳戶集中管理',
    '刷新资产': '刷新資產',
    '账户划转': '帳戶劃轉',
    '总资产 (USDT)': '總資產 (USDT)',
    'USDT 总资产': 'USDT 總資產',
    '燃料账户、资金账户和点卡账户资产分布': '燃料帳戶、資金帳戶和點卡帳戶資產分佈',
    '暂无资产分布数据': '暫無資產分佈資料',
    '资金账户': '資金帳戶',
    '燃料账户': '燃料帳戶',
    '点卡账户': '點卡帳戶',
    '点卡账户 (折算)': '點卡帳戶（折算）',
    '用于充值、提现与内部划转。': '用於充幣、提幣與內部劃轉。',
    '用于机器人运行与平台服务结算。': '用於機器人運行與平台服務結算。',
    '用于抵扣平台服务费，消费时优先扣除。': '用於抵扣平台服務費，消費時優先扣除。',
    '充值': '充幣',
    '提现': '提幣',
    '划转': '劃轉',
    '查看账单': '查看帳單',
    '购买点卡': '購買點卡',
    '消费记录': '消費記錄',
    '充值提现订单': '充幣提幣訂單',
    '资金流水': '資金流水',
    '充值订单': '充幣訂單',
    '提现订单': '提幣訂單',
    '订单状态': '訂單狀態',
    '全部状态': '全部狀態',
    '已完成': '已完成',
    '处理中': '處理中',
    '审核中': '審核中',
    '刷新': '刷新',
    '时间': '時間',
    '账户': '帳戶',
    '币种': '幣種',
    '数量': '數量',
    '渠道 · 地址': '渠道 · 地址',
    '状态': '狀態',
    '已关闭': '已關閉',
    '正在同步订单…': '正在同步訂單…',
    '暂无订单数据': '暫無訂單資料',
    '充值与提现订单与账单页资金流水保持一致，可交叉核对。': '充幣與提幣訂單和帳單頁資金流水保持一致，可交叉核對。',
    '资产数据同步中': '資產資料同步中',
    '资产数据尚未同步': '資產資料尚未同步',
    '今天': '今天',
    '链上数据已同步': '鏈上資料已同步',
    '账单': '帳單',
    '每一笔收益、扣费与账户变化，透明可查': '每一筆收益、扣費與帳戶變化，透明可查',
    '账单月份': '帳單月份',
    '导出当月账单': '匯出當月帳單',
    '本月服务费 (USDT)': '本月服務費 (USDT)',
    '较上月': '較上月',
    '本月结算收益 (USDT)': '本月結算收益 (USDT)',
    '实时': '實時',
    '可用点卡': '可用點卡',
    '点': '點',
    '账单明细': '帳單明細',
    '逐笔可查': '逐筆可查',
    '燃料 / 点卡记录': '燃料 / 點卡記錄',
    '燃料 / 点卡': '燃料 / 點卡',
    '充值 / 提现记录': '充值 / 提現記錄',
    '充值 / 提现': '充值 / 提現',
    '购买点卡 / 资金划转记录': '購買點卡 / 資金劃轉記錄',
    '购买点卡/资金划转': '購買點卡/資金劃轉',
    '类别查询': '類別查詢',
    '充值记录': '充值記錄',
    '提现记录': '提現記錄',
    '燃料划转': '燃料劃轉',
    '个人中心': '個人中心',
    '通知中心': '通知中心',
    '搜索策略 / 币种': '搜尋策略 / 幣種',
    '帮助中心': '幫助中心',
    '退出': '退出',
    '退出登录': '退出登入',
    '重新加载交易所': '重新載入交易所',
    '交易所加载失败': '交易所載入失敗',
    '暂无可用交易所': '暫無可用交易所',
    '交易所列表读取失败': '交易所列表讀取失敗',
    '交易所列表数据异常': '交易所列表資料異常',
    '返回登录': '返回登入',
    '登录': '登入',
    '注册': '註冊',
    '取消': '取消',
    '确定': '確定',
    '确认': '確認',
    '关闭': '關閉',
    '修改': '修改',
    '删除': '刪除',
    '恢复': '恢復',
    '暂停': '暫停',
    '查看更多': '查看更多',
    '加载中…': '載入中…',
    '暂无数据': '暫無資料',
    '系统运行正常': '系統運行正常',
    '币币策略最小仓位读取失败': '幣幣策略最小倉位讀取失敗',
    '未找到当前币币策略的交易对配置': '未找到目前幣幣策略的交易對設定',
    '机器人页面尚未加载当前交易所状态': '機器人頁面尚未載入目前交易所狀態',
    '请输入有效的杠杆倍数': '請輸入有效的槓桿倍數',
    '我已了解暂停策略可能影响当前挂单与持仓': '我已瞭解暫停策略可能影響目前掛單與持倉',
    '请先确认已了解暂停策略的风险': '請先確認已瞭解暫停策略的風險',
    'FITFI 投入金额不能超过 2000 USDT': 'FITFI 投入金額不能超過 2000 USDT',
    '只授权交易，不授权提币': '只授權交易，不授權提幣',
    '绑定时请勿开启提币权限；建议同时配置 IP 白名单以提升安全性。': '綁定時請勿開啟提幣權限；建議同時設定 IP 白名單以提升安全性。',
    '登录保护': '登入保護',
    '台运行中': '台運行中',
    '条策略': '條策略',
    'AI智能化策略': 'AI 智能化策略',
    '100 USDT 开启，AI 智能选指标并自动运行': '100 USDT 開啟，AI 智能選指標並自動運行',
    '比普通版收益高，覆盖范围适中': '比普通版收益高，覆蓋範圍適中',
    '收益最高的版本，下跌覆盖 30% 左右，适合主流币': '收益最高的版本，下跌覆蓋 30% 左右，適合主流幣',
    '请先删除当前仓位后再修改策略': '請先刪除目前倉位後再修改策略',
    '内部转账失败': '內部轉帳失敗',
    '，请手动启动机器人': '，請手動啟動機器人',
    '修改后的投入金额低于当前投入金额，确认继续修改吗？': '修改後的投入金額低於目前投入金額，確認繼續修改嗎？',
    'AI 网格': 'AI 網格',
    '全自动 AI 交易，适合所有行情': '全自動 AI 交易，適合所有行情',
    '启动 UPlus-S1': '啟動 UPlus-S1',
    '请输入投入金额': '請輸入投入金額',
    '可用余额': '可用餘額',
    '最低 1,000 USDT，最高 20,000 USDT': '最低 1,000 USDT，最高 20,000 USDT',
    '固定杠杆': '固定槓桿',
    '固定使用 10x 杠杆': '固定使用 10x 槓桿',
    '策略参数由 Orbit 自动管理，创建后将根据行情独立运行。': '策略參數由 Orbit 自動管理，建立後將根據行情獨立運行。',
    '确认启动': '確認啟動',
    '可用余额读取失败': '可用餘額讀取失敗',
    '请输入有效的投入金额': '請輸入有效的投入金額',
    'Orbit 策略投入金额不能低于 1,000 USDT': 'Orbit 策略投入金額不能低於 1,500 USDT',
    'Orbit 策略投入金额不能超过 20,000 USDT': 'Orbit 策略投入金額不能超過 20,000 USDT',
    '请先成功读取交易所可用余额': '請先成功讀取交易所可用餘額',
    'UPlus-S1合约交易风险提示': 'UPlus-S1 合約交易風險提示',
    'Orbit 策略创建失败': 'Orbit 策略建立失敗',
    'Orbit 策略创建失败，请稍后重试': 'Orbit 策略建立失敗，請稍後重試',
    'UPlus-S1 创建成功': 'UPlus-S1 建立成功',
    '确认减少投入金额': '確認減少投入金額'
  },
  en: {
    '总览': 'Overview',
    '机器人': 'Bots',
    '收益': 'Earnings',
    '资产': 'Assets',
    '账单': 'Billing',
    '个人中心': 'Profile',
    '通知中心': 'Notifications',
    '帮助中心': 'Help Center',
    '退出': 'Log out',
    '退出登录': 'Log out',
    '重新加载交易所': 'Reload exchanges',
    '交易所加载失败': 'Exchange load failed',
    '暂无可用交易所': 'No available exchanges',
    '交易所列表读取失败': 'Failed to load the exchange list',
    '交易所列表数据异常': 'Invalid exchange list data',
    '返回登录': 'Back to login',
    '登录': 'Log in',
    '注册': 'Sign up',
    '取消': 'Cancel',
    '确定': 'Confirm',
    '确认': 'Confirm',
    '关闭': 'Close',
    '修改': 'Edit',
    '删除': 'Delete',
    '恢复': 'Resume',
    '暂停': 'Pause',
    '查看更多': 'View more',
    '加载中…': 'Loading…',
    '暂无数据': 'No data',
    '系统运行正常': 'System operational'
  },
  ko: {
    '总览': '개요',
    '机器人': '봇',
    '收益': '수익',
    '资产': '자산',
    '账单': '청구 내역',
    '个人中心': '개인 센터',
    '通知中心': '알림 센터',
    '帮助中心': '도움말 센터',
    '退出': '로그아웃',
    '退出登录': '로그아웃',
    '重新加载交易所': '거래소 다시 불러오기',
    '交易所加载失败': '거래소 로드 실패',
    '暂无可用交易所': '사용 가능한 거래소 없음',
    '交易所列表读取失败': '거래소 목록을 불러오지 못했습니다',
    '交易所列表数据异常': '거래소 목록 데이터 오류',
    '返回登录': '로그인으로 돌아가기',
    '登录': '로그인',
    '注册': '회원가입',
    '取消': '취소',
    '确定': '확인',
    '确认': '확인',
    '关闭': '닫기',
    '修改': '수정',
    '删除': '삭제',
    '恢复': '재개',
    '暂停': '일시정지',
    '查看更多': '더 보기',
    '加载中…': '로딩 중…',
    '暂无数据': '데이터 없음',
    '系统运行正常': '시스템 정상 운영 중'
  }
}

function flatten(value, path = '', output = {}) {
  if (typeof value === 'string') {
    output[path] = value.trim()
    return output
  }
  if (!value || typeof value !== 'object') return output
  Object.keys(value).forEach(key => {
    flatten(value[key], path ? `${path}.${key}` : key, output)
  })
  return output
}

function loadCatalog(context) {
  const output = {}
  context.keys().sort().forEach(file => {
    const name = file.replace(/^\.\//, '').replace(/\.json$/, '')
    flatten(context(file), name, output)
  })
  return output
}

const sourceCatalog = loadCatalog(sourceContext)
const targetCatalogs = Object.keys(TARGET_CONTEXTS).reduce((output, locale) => {
  output[locale] = loadCatalog(TARGET_CONTEXTS[locale])
  return output
}, {})

const sourceIndex = Object.keys(sourceCatalog).reduce((output, key) => {
  const value = sourceCatalog[key]
  if (value && !output[value]) output[value] = key
  return output
}, {})

function buildFragmentTranslations(locale) {
  const translations = new Map()
  const targetCatalog = targetCatalogs[locale] || {}

  Object.keys(sourceCatalog).forEach(key => {
    const source = sourceCatalog[key]
    const target = targetCatalog[key]
    if (source && target && source !== target && /[\u3400-\u9fff]/.test(source) && source.length >= 2) {
      translations.set(source, target)
    }
  })
  Object.keys((pcMessages && pcMessages[locale]) || {}).forEach(source => {
    const target = pcMessages[locale][source]
    if (target && source !== target && /[\u3400-\u9fff]/.test(source) && source.length >= 2) {
      translations.set(source, target)
    }
  })
  Object.keys((PC_OVERRIDES && PC_OVERRIDES[locale]) || {}).forEach(source => {
    const target = PC_OVERRIDES[locale][source]
    if (target && source !== target && /[\u3400-\u9fff]/.test(source) && source.length >= 2) {
      translations.set(source, target)
    }
  })

  return Array.from(translations.entries())
    .sort((left, right) => right[0].length - left[0].length)
}

const fragmentTranslations = {
  en: buildFragmentTranslations('en'),
  ko: buildFragmentTranslations('ko')
}
const fragmentCaches = {
  en: new Map(),
  ko: new Map()
}

function translateByFragments(source, locale) {
  if (!/[\u3400-\u9fff]/.test(source)) return ''
  const cache = fragmentCaches[locale]
  if (cache && cache.has(source)) return cache.get(source)
  let output = source
  let changed = false
  ;(fragmentTranslations[locale] || []).forEach(([from, to]) => {
    if (!output.includes(from)) return
    output = output.split(from).join(to)
    changed = true
  })
  const translated = changed ? output : ''
  if (cache) cache.set(source, translated)
  return translated
}

const hongKongConverter = OpenCC.Converter({ from: 'cn', to: 'hk' })

function toHongKongTraditional(value) {
  let output = String(value || '')
  // Some OpenCC phrase replacements unlock a second character-level conversion
  // (for example, 賬户 -> 賬戶). Run to a stable value to avoid mixed glyphs.
  for (let index = 0; index < 3; index += 1) {
    const converted = hongKongConverter(output)
    if (converted === output) break
    output = converted
  }
  // opencc-js 1.x 的 cn -> hk 词表会产生“賬户”这类混合字形；
  // 香港繁体界面必须统一使用传统字形“戶”。
  return output.replace(/户/g, '戶')
}

export const localeState = Vue.observable({ current: readLanguage() })

export function translateKey(key, locale = localeState.current) {
  const normalizedLocale = normalizeLanguage(locale)
  const source = sourceCatalog[key] || key
  if (normalizedLocale === 'zh-CN') return source
  const translated = (targetCatalogs[normalizedLocale] && targetCatalogs[normalizedLocale][key]) || source
  return normalizedLocale === 'zh-HK' ? toHongKongTraditional(translated) : translated
}

function preserveWhitespace(source, translated) {
  const leading = source.match(/^\s*/)[0]
  const trailing = source.match(/\s*$/)[0]
  return `${leading}${translated}${trailing}`
}

const DYNAMIC_TRANSLATIONS = {
  en: {
    risk: value => `${value} risk`,
    bots: value => `${value} bots`,
    orders: value => `${value} orders`,
    strategies: value => `${value} strategies`,
    records: value => `${value} records`,
    unread: value => `${value} unread`,
    runningBots: value => `Running ${value} bots`,
    followingCapital: value => `Capital following ${value}`,
    year: value => value,
    month: value => `${value}`,
    yearMonth: (year, month) => `${year}-${String(month).padStart(2, '0')}`,
    pageSummary: (total, page, pages) => `${total} records · Page ${page} / ${pages}`,
    bound: (current, total) => `${current} / ${total} bound`,
    days: value => `${value} days`,
    articles: value => `${value} articles`,
    transactions: value => `${value} transactions`,
    resend: value => `Resend in ${value}s`,
    rank: value => `Rank ${value}`,
    monthDay: (month, day) => `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
    totalRows: (total, size) => size ? `${total} total · ${size} per page` : `${total} total`,
    totalMessages: value => `${value} messages`,
    totalStrategyRows: value => `${value} strategies`,
    totalProducts: value => `${value} strategy products`,
    totalSettlements: value => `${value} settlements`,
    totalWithSuffix: (value, suffix) => `${value} total · ${suffix}`,
    faqSummary: (value, suffix) => `${value} FAQs · ${suffix}`,
    botsInUse: value => `${value} bots in use`,
    positionMinimum: (coin, minimum) => `${coin} position cannot be below ${minimum}`,
    investmentMinimum: (coin, minimum) => `${coin} investment cannot be below ${minimum}`,
    availableBalanceInsufficient: coin => `Insufficient available ${coin} balance`,
    namedMinimum: (label, minimum) => `${label} cannot be below ${minimum}`,
    validPosition: coin => `Enter a valid ${coin} position`,
    positionMaximum: (coin, maximum) => `${coin} position cannot exceed ${maximum}`,
    noAvailableBalance: coin => `No available ${coin} balance`,
    currentStrategyMinimum: minimum => `Current strategy investment cannot be below ${minimum} USDT`,
    capacityInvalid: label => `${label} position capacity data is invalid; creation is unavailable`,
    capacityExhausted: label => `${label} position capacity is exhausted`,
    capacityNotLoaded: label => `${label} position capacity has not loaded`,
    capacityExceeded: (label, remaining) => `This investment exceeds ${label}'s remaining position capacity of ${remaining} USDT`,
    okxExclusive: link => `OKX exclusive user: an exchange member registered through the OKX exclusive link (${link}) or invitation code (UPLUS3).`,
    coinMinimum: (coin, minimum) => `${coin} (minimum ${minimum} USDT)`,
    bonusAmount: value => `(Bonus: ${value} USDT credit)`,
    notificationUnread: value => `Notifications, ${value} unread`,
    searchResults: value => `Search results · ${value}`,
    verificationCodeValidity: (account, minutes) => `Verification code sent to ${account}. Valid for ${minutes} minutes.`,
    startedCount: value => `Started ${value};`,
    closedCount: value => `Closed ${value};`,
    robotStartedStrategies: value => `Bot started; ${value} strategies are now running`,
    confirmCloseRobot: exchange => `Are you sure you want to turn off the ${exchange} bot?`,
    bindApiAuthorization: exchange => `Go to “Exchange API Authorization” and bind the ${exchange} exchange API first`,
    strategyActionSuccess: (action, synced) => {
      const actionText = {
        修改: 'updated',
        暂停: 'paused',
        恢复: 'resumed',
        删除: 'deleted',
        操作: 'operation completed'
      }[action] || action
      return synced
        ? `Strategy ${actionText} successfully; list resynced`
        : `Strategy ${actionText} successfully`
    },
    strategyCreated: name => `${name} created successfully; strategy list resynced`,
    healthSummary: (healthy, attention, high) => `${healthy} healthy · ${attention} attention · ${high} high risk`,
    messageLength: (minimum, maximum) => `Message must contain ${minimum}-${maximum} characters`,
    runningToday: value => `${value} running · Today`,
    settledCaption: value => `${value} settled · Automatically credited`,
    cardBonus: (amount, bonus) => `${amount} USDT (Bonus: ${bonus} USDT credit)`,
    receiverAccount: value => `Recipient account: ${value}`,
    paymentDeadline: value => `Complete payment before ${value}. Generate a new deposit order if it expires.`,
    chainProtocol: value => `1. The current USDT payment network is ${value}.`,
    currentInvestment: value => `Current investment: ${value} USDT`,
    coinInvestment: value => `${value} investment`,
    maximumLeverage: value => `Maximum leverage: ${value}x`,
    winRate: value => `Win rate ${value}`,
    registeredAt: value => `Registered ${value}`,
    bindingExchange: value => `Binding ${value} account API`,
    createdAt: value => `· Created ${value}`,
    syncingNamedRecords: value => `Syncing ${value}…`,
    noMatchingNamedRecords: value => `No matching ${value}`,
    metricWithUnit: (label, unit) => `${({
      '保证金余额': 'Margin balance',
      '初始保证金': 'Initial margin',
      '浮动盈亏': 'Unrealized P&L',
      '今日收益': 'Today earnings',
      '累计峰值': 'Cumulative peak',
      '投入金额': 'Investment',
      '总收益': 'Total earnings'
    })[label] || label} (${unit})`
  },
  ko: {
    risk: value => `${value} 위험`,
    bots: value => `${value}대`,
    orders: value => `${value}건`,
    strategies: value => `${value}개 전략`,
    records: value => `${value}개 기록`,
    unread: value => `읽지 않음 ${value}개`,
    runningBots: value => `실행 중 ${value}대`,
    followingCapital: value => `추종 자금 ${value}`,
    year: value => `${value}년`,
    month: value => `${value}월`,
    yearMonth: (year, month) => `${year}년 ${month}월`,
    pageSummary: (total, page, pages) => `총 ${total}개 · ${page} / ${pages}페이지`,
    bound: (current, total) => `${current} / ${total} 바인딩됨`,
    days: value => `${value}일`,
    articles: value => `${value}개 문서`,
    transactions: value => `${value}건`,
    resend: value => `${value}초 후 재전송`,
    rank: value => `${value}위`,
    monthDay: (month, day) => `${month}월 ${day}일`,
    totalRows: (total, size) => size ? `총 ${total}개 · 페이지당 ${size}개` : `총 ${total}개`,
    totalMessages: value => `총 ${value}개 메시지`,
    totalStrategyRows: value => `총 ${value}개 전략`,
    totalProducts: value => `총 ${value}개 전략 상품`,
    totalSettlements: value => `총 ${value}건 정산`,
    totalWithSuffix: (value, suffix) => `총 ${value}개 · ${suffix}`,
    faqSummary: (value, suffix) => `자주 묻는 질문 ${value}개 · ${suffix}`,
    botsInUse: value => `${value}개 봇 사용 중`,
    positionMinimum: (coin, minimum) => `${coin} 포지션은 ${minimum} 이상이어야 합니다`,
    investmentMinimum: (coin, minimum) => `${coin} 투자 금액은 ${minimum} 이상이어야 합니다`,
    availableBalanceInsufficient: coin => `${coin} 가용 잔액이 부족합니다`,
    namedMinimum: (label, minimum) => `${label}: ${minimum} 이상이어야 합니다`,
    validPosition: coin => `유효한 ${coin} 포지션을 입력해 주세요`,
    positionMaximum: (coin, maximum) => `${coin} 포지션은 ${maximum}을(를) 초과할 수 없습니다`,
    noAvailableBalance: coin => `${coin} 가용 잔액이 없습니다`,
    currentStrategyMinimum: minimum => `현재 전략 투자 금액은 ${minimum} USDT 이상이어야 합니다`,
    capacityInvalid: label => `${label} 생성 가능 포지션 한도 데이터가 올바르지 않아 생성할 수 없습니다`,
    capacityExhausted: label => `${label} 생성 가능 포지션 한도를 모두 사용했습니다`,
    capacityNotLoaded: label => `${label} 생성 가능 포지션 한도를 아직 불러오지 못했습니다`,
    capacityExceeded: (label, remaining) => `이번 투자 금액이 ${label}의 남은 포지션 한도 ${remaining} USDT를 초과합니다`,
    okxExclusive: link => `OKX 전용 사용자: OKX 전용 링크(${link}) 또는 초대 코드(UPLUS3)로 가입한 거래소 회원입니다.`,
    coinMinimum: (coin, minimum) => `${coin} (최소 ${minimum} USDT)`,
    bonusAmount: value => `(보너스 ${value} USDT 한도)`,
    notificationUnread: value => `알림, 읽지 않음 ${value}개`,
    searchResults: value => `검색 결과 · ${value}`,
    verificationCodeValidity: (account, minutes) => `${account}(으)로 인증 코드를 보냈습니다. ${minutes}분 동안 유효합니다.`,
    startedCount: value => `${value}개 시작됨;`,
    closedCount: value => `${value}개 종료됨;`,
    robotStartedStrategies: value => `봇이 시작되어 ${value}개 전략이 실행 중입니다`,
    confirmCloseRobot: exchange => `${exchange} 봇을 종료하시겠습니까?`,
    bindApiAuthorization: exchange => `먼저 “거래소 API 인증” 페이지에서 ${exchange} 거래소 API를 연결해 주세요`,
    strategyActionSuccess: (action, synced) => {
      const actionText = {
        修改: '수정',
        暂停: '일시정지',
        恢复: '재개',
        删除: '삭제',
        操作: '처리'
      }[action] || action
      return synced
        ? `전략 ${actionText} 성공; 목록이 다시 동기화되었습니다`
        : `전략 ${actionText} 성공`
    },
    strategyCreated: name => `${name} 생성 완료; 전략 목록이 다시 동기화되었습니다`,
    healthSummary: (healthy, attention, high) => `양호 ${healthy} · 주의 ${attention} · 고위험 ${high}`,
    messageLength: (minimum, maximum) => `메시지는 ${minimum}-${maximum}자로 입력해 주세요`,
    runningToday: value => `${value}개 실행 중 · 오늘`,
    settledCaption: value => `${value}건 정산 · 자동 입금`,
    cardBonus: (amount, bonus) => `${amount} USDT (보너스 ${bonus} USDT 한도)`,
    receiverAccount: value => `수신 계정: ${value}`,
    paymentDeadline: value => `${value} 전까지 결제를 완료하세요. 만료되면 새 충전 주문을 생성하세요.`,
    chainProtocol: value => `1. 현재 USDT 결제 네트워크는 ${value}입니다.`,
    currentInvestment: value => `현재 투자: ${value} USDT`,
    coinInvestment: value => `${value} 투자`,
    maximumLeverage: value => `최대 레버리지: ${value}x`,
    winRate: value => `승률 ${value}`,
    registeredAt: value => `${value} 가입`,
    bindingExchange: value => `${value} 계정 API 연결 중`,
    createdAt: value => `· 생성일 ${value}`,
    syncingNamedRecords: value => `${value} 동기화 중…`,
    noMatchingNamedRecords: value => `조건에 맞는 ${value}이(가) 없습니다`,
    metricWithUnit: (label, unit) => `${({
      '保证金余额': '증거금 잔액',
      '初始保证金': '초기 증거금',
      '浮动盈亏': '미실현 손익',
      '今日收益': '오늘 수익',
      '累计峰值': '누적 최고치',
      '投入金额': '투자 금액',
      '总收益': '총수익'
    })[label] || label} (${unit})`
  },
  'zh-HK': {
    risk: value => `${value}風險`,
    bots: value => `${value}台`,
    orders: value => `${value}單`,
    strategies: value => `${value}個策略`,
    records: value => `${value}條記錄`,
    unread: value => `${value}條未讀`,
    runningBots: value => `運行中 ${value} 台`,
    followingCapital: value => `跟隨資金 ${value}`,
    year: value => `${value}年`,
    month: value => `${value}月`,
    yearMonth: (year, month) => `${year}年${month}月`,
    pageSummary: (total, page, pages) => `共 ${total} 條記錄 · 第 ${page} / ${pages} 頁`,
    bound: (current, total) => `${current} / ${total} 已綁定`,
    days: value => `${value}天`,
    articles: value => `${value}篇`,
    transactions: value => `${value}筆`,
    resend: value => `${value} 秒後重發`,
    rank: value => `第 ${value} 名`,
    monthDay: (month, day) => `${month}月${day}日`,
    totalRows: (total, size) => size ? `共 ${total} 條，每頁 ${size} 條` : `共 ${total} 條`,
    totalMessages: value => `共 ${value} 條消息`,
    totalStrategyRows: value => `共 ${value} 條策略`,
    totalProducts: value => `共 ${value} 個策略產品`,
    totalSettlements: value => `共結算 ${value} 筆`,
    totalWithSuffix: (value, suffix) => `共 ${value} 條 · ${suffix}`,
    faqSummary: (value, suffix) => `${value} 篇常見問題 · ${suffix}`,
    botsInUse: value => `${value} 台機器人使用中`,
    positionMinimum: (coin, minimum) => `${coin} 倉位不能低於 ${minimum}`,
    investmentMinimum: (coin, minimum) => `${coin} 投入不能低於 ${minimum}`,
    availableBalanceInsufficient: coin => `${coin} 可用餘額不足`,
    namedMinimum: (label, minimum) => `${label}不能低於 ${minimum}`,
    validPosition: coin => `請輸入有效的 ${coin} 倉位`,
    positionMaximum: (coin, maximum) => `${coin} 倉位不能超過 ${maximum}`,
    noAvailableBalance: coin => `${coin} 沒有可用餘額`,
    currentStrategyMinimum: minimum => `目前策略投入金額不能低於 ${minimum} USDT`,
    capacityInvalid: label => `${label}可建立倉位額度資料異常，暫不能建立`,
    capacityExhausted: label => `${label}可建立倉位額度已用完`,
    capacityNotLoaded: label => `${label}可建立倉位額度尚未載入`,
    capacityExceeded: (label, remaining) => `${label}本次投入超過剩餘可建立倉位 ${remaining} USDT`,
    okxExclusive: link => `OKX 專屬用戶：透過 OKX 專屬連結（${link}）或邀請碼（UPLUS3）註冊的交易所會員。`,
    coinMinimum: (coin, minimum) => `${coin}（最低 ${minimum} USDT）`,
    bonusAmount: value => `（贈送 ${value} USDT 額度）`,
    notificationUnread: value => `通知，${value} 條未讀`,
    searchResults: value => `搜尋結果 · ${value}`,
    verificationCodeValidity: (account, minutes) => `驗證碼已發送至 ${account}，${minutes} 分鐘內有效`,
    startedCount: value => `已啟動 ${value} 個；`,
    closedCount: value => `已關閉 ${value} 個；`,
    robotStartedStrategies: value => `機器人已啟動，${value} 個策略開始運行`,
    confirmCloseRobot: exchange => `確定要關閉 ${exchange} 機器人嗎？`,
    bindApiAuthorization: exchange => `請先至「交易所 API 授權」頁面，綁定 ${exchange} 交易所 API`,
    strategyActionSuccess: (action, synced) => {
      const actionText = {
        修改: '修改',
        暂停: '暫停',
        恢复: '恢復',
        删除: '刪除',
        操作: '操作'
      }[action] || action
      return synced
        ? `策略${actionText}成功，列表已重新同步`
        : `策略${actionText}成功`
    },
    strategyCreated: name => `${name} 建立成功，策略列表已重新同步`,
    healthSummary: (healthy, attention, high) => `${healthy} 良好 · ${attention} 關注 · ${high} 高風險`,
    messageLength: (minimum, maximum) => `消息內容應為 ${minimum}-${maximum} 個字符`,
    runningToday: value => `${value} 個運行中 · 今日`,
    settledCaption: value => `已結算 ${value} 筆 · 自動結算入帳`,
    cardBonus: (amount, bonus) => `${amount} USDT（贈送 ${bonus} USDT 額度）`,
    receiverAccount: value => `接收帳戶：${value}`,
    paymentDeadline: value => `請在 ${value} 之前完成付款，逾時請重新產生充值訂單。`,
    chainProtocol: value => `1. 當前 USDT 支付公鏈協議為 ${value}。`,
    currentInvestment: value => `當前投入：${value} USDT`,
    coinInvestment: value => `${value} 投入`,
    maximumLeverage: value => `最大槓桿：${value}x`,
    winRate: value => `勝率 ${value}`,
    registeredAt: value => `註冊於 ${value}`,
    bindingExchange: value => `正在綁定 ${value} 帳戶 API`,
    createdAt: value => `· 建立於 ${value}`,
    syncingNamedRecords: value => `正在同步${value}…`,
    noMatchingNamedRecords: value => `暫無符合條件的${value}`,
    metricWithUnit: (label, unit) => `${({
      '保证金余额': '保證金餘額',
      '初始保证金': '初始保證金',
      '浮动盈亏': '浮動盈虧',
      '今日收益': '今日收益',
      '累计峰值': '累計峰值',
      '投入金额': '投入金額',
      '总收益': '總收益'
    })[label] || label} (${unit})`
  }
}

function translateDynamic(source, locale) {
  const handlers = DYNAMIC_TRANSLATIONS[locale]
  if (!handlers) return ''

  let matched = source.match(/^接收账号：\s*(.+)$/)
  if (matched) return handlers.receiverAccount(matched[1])
  matched = source.match(/^(.+?)\s+之前完成付款，超时请重新生成充值订单。$/)
  if (matched) return handlers.paymentDeadline(matched[1])
  matched = source.match(/^1\.\s*当前 USDT 支付公链协议为\s*(.+?)。$/)
  if (matched) return handlers.chainProtocol(matched[1])
  matched = source.match(/^当前投入：\s*(.+?)\s*USDT$/)
  if (matched) return handlers.currentInvestment(matched[1])
  matched = source.match(/^([^\s]+)\s+投入$/)
  if (matched) return handlers.coinInvestment(matched[1])
  matched = source.match(/^最大杠杆：\s*(.+?)x$/)
  if (matched) return handlers.maximumLeverage(matched[1])
  matched = source.match(/^胜率\s+(.+)$/)
  if (matched) return handlers.winRate(matched[1])
  matched = source.match(/^注册于\s+(.+)$/)
  if (matched) return handlers.registeredAt(matched[1])
  matched = source.match(/^正在绑定\s+(.+?)\s+账户 API$/)
  if (matched) return handlers.bindingExchange(matched[1])
  matched = source.match(/^·\s*创建于\s+(.+)$/)
  if (matched) return handlers.createdAt(matched[1])
  matched = source.match(/^正在同步(.+?)…$/)
  if (matched) return handlers.syncingNamedRecords(translateText(matched[1], locale))
  matched = source.match(/^暂无符合条件的(.+)$/)
  if (matched) return handlers.noMatchingNamedRecords(translateText(matched[1], locale))
  matched = source.match(/^通知，\s*(\d+)\s*条未读$/)
  if (matched) return handlers.notificationUnread(matched[1])
  matched = source.match(/^搜索结果\s*·\s*(\d+)$/)
  if (matched) return handlers.searchResults(matched[1])
  matched = source.match(/^验证码已发送至\s+(.+?)，\s*(\d+)\s*分钟内有效$/)
  if (matched) return handlers.verificationCodeValidity(matched[1], matched[2])
  matched = source.match(/^已启动\s*(\d+)\s*个；$/)
  if (matched) return handlers.startedCount(matched[1])
  matched = source.match(/^已关闭\s*(\d+)\s*个；$/)
  if (matched) return handlers.closedCount(matched[1])
  matched = source.match(/^机器人已启动，\s*(\d+)\s*台策略开始运行$/)
  if (matched) return handlers.robotStartedStrategies(matched[1])
  matched = source.match(/^确定要关闭\s+(.+?)\s+机器人吗？$/)
  if (matched) return handlers.confirmCloseRobot(matched[1])
  matched = source.match(/^请先至[“「]交易所 API 授权[”」]页面，绑定\s+(.+?)\s+交易所 API$/)
  if (matched) return handlers.bindApiAuthorization(matched[1])
  matched = source.match(/^策略(修改|暂停|恢复|删除|操作)成功(，列表已重新同步)?$/)
  if (matched) return handlers.strategyActionSuccess(matched[1], Boolean(matched[2]))
  matched = source.match(/^(.+?)\s+创建成功，策略列表已重新同步$/)
  if (matched) return handlers.strategyCreated(matched[1])
  matched = source.match(/^(.+?)\s+良好\s*·\s*(.+?)\s+关注\s*·\s*(.+?)\s+高风险$/)
  if (matched) return handlers.healthSummary(matched[1], matched[2], matched[3])
  matched = source.match(/^消息内容应为\s*(\d+)-(.+?)个字符$/)
  if (matched) return handlers.messageLength(matched[1], matched[2])
  matched = source.match(/^(.+?)\s*台运行中\s*·\s*今日$/)
  if (matched) return handlers.runningToday(matched[1])
  matched = source.match(/^已结算\s*(.+?)\s*笔\s*·\s*自动结算入账$/)
  if (matched) return handlers.settledCaption(matched[1])
  matched = source.match(/^(.+?)\s+USDT（赠送\s+(.+?)\s+USDT额度）$/)
  if (matched) return handlers.cardBonus(matched[1], matched[2])
  matched = source.match(/^(保证金余额|初始保证金|浮动盈亏|今日收益|累计峰值|投入金额|总收益)\s*\((.+?)\)$/)
  if (matched) return handlers.metricWithUnit(matched[1], matched[2])
  matched = source.match(/^共结算\s*(.+?)\s*笔$/)
  if (matched) return handlers.totalSettlements(matched[1])
  matched = source.match(/^(.+)风险$/)
  if (matched) return handlers.risk(matched[1])
  matched = source.match(/^在运行\s*(.+?)\s*台$/)
  if (matched) return handlers.runningBots(matched[1])
  matched = source.match(/^(.+?)\s*台机器人使用中$/)
  if (matched) return handlers.botsInUse(matched[1])
  matched = source.match(/^(.+?)\s*台策略$/)
  if (matched) return handlers.strategies(matched[1])
  matched = source.match(/^请输入有效的 (.+?) 仓位$/)
  if (matched) return handlers.validPosition(matched[1])
  matched = source.match(/^(.+?) 仓位不能超过 (.+)$/)
  if (matched) return handlers.positionMaximum(matched[1], matched[2])
  matched = source.match(/^(.+?) 没有可用余额$/)
  if (matched) return handlers.noAvailableBalance(matched[1])
  matched = source.match(/^当前策略投入金额不能低于 (.+?) USDT$/)
  if (matched) return handlers.currentStrategyMinimum(matched[1])
  matched = source.match(/^(.+?)可创建仓位额度数据异常，暂不能创建$/)
  if (matched) return handlers.capacityInvalid(translateText(matched[1], locale))
  matched = source.match(/^(.+?)可创建仓位额度已用完$/)
  if (matched) return handlers.capacityExhausted(translateText(matched[1], locale))
  matched = source.match(/^(.+?)可创建仓位额度尚未加载$/)
  if (matched) return handlers.capacityNotLoaded(translateText(matched[1], locale))
  matched = source.match(/^(.+?)本次投入超过剩余可创建仓位 (.+?) USDT$/)
  if (matched) return handlers.capacityExceeded(translateText(matched[1], locale), matched[2])
  matched = source.match(/^(.+?)\s+仓位不能低于\s+(.+)$/)
  if (matched) return handlers.positionMinimum(matched[1], matched[2])
  matched = source.match(/^(.+?)\s+投入不能低于\s+(.+)$/)
  if (matched) return handlers.investmentMinimum(matched[1], matched[2])
  matched = source.match(/^(.+?)\s+可用余额不足$/)
  if (matched) return handlers.availableBalanceInsufficient(matched[1])
  matched = source.match(/^(当前币种投入金额|补仓金额|最大持仓|新的最大持仓|OKX 马丁策略首单额度)不能(?:低于|小于)\s+(.+)$/)
  if (matched) return handlers.namedMinimum(translateText(matched[1], locale), matched[2])
  matched = source.match(/^Okx专属用户：通过OKX专属链接（(.+)）或邀请码（UPLUS3）注册的交易所会员。$/)
  if (matched) return handlers.okxExclusive(matched[1])
  matched = source.match(/^(.+)（最小\s+(.+)\s+USDT）$/)
  if (matched) return handlers.coinMinimum(matched[1], matched[2])
  matched = source.match(/^（赠送\s+(.+)\s+USDT额度）$/)
  if (matched) return handlers.bonusAmount(matched[1])
  matched = source.match(/^跟随资金\s*(.+)$/)
  if (matched) return handlers.followingCapital(matched[1])
  matched = source.match(/^(\d+)\s*(?:秒|s)\s*后重发$/)
  if (matched) return handlers.resend(matched[1])
  matched = source.match(/^(.+)\s*天$/)
  if (matched) return handlers.days(matched[1])
  matched = source.match(/^(.+)\s*篇$/)
  if (matched) return handlers.articles(matched[1])
  matched = source.match(/^(.+)\s*笔$/)
  if (matched) return handlers.transactions(matched[1])
  matched = source.match(/^第\s*(\d+)\s*名$/)
  if (matched) return handlers.rank(matched[1])
  matched = source.match(/^(\d{1,2})月(\d{1,2})日$/)
  if (matched) return handlers.monthDay(matched[1], matched[2])
  matched = source.match(/^共\s*(.+?)\s*条，每页\s*(.+?)\s*条$/)
  if (matched) return handlers.totalRows(matched[1], matched[2])
  matched = source.match(/^共\s*(.+?)\s*条消息$/)
  if (matched) return handlers.totalMessages(matched[1])
  matched = source.match(/^共\s*(.+?)\s*条策略$/)
  if (matched) return handlers.totalStrategyRows(matched[1])
  matched = source.match(/^共\s*(.+?)\s*个策略产品$/)
  if (matched) return handlers.totalProducts(matched[1])
  matched = source.match(/^共\s*(.+?)\s*条\s*·\s*(.+)$/)
  if (matched) return handlers.totalWithSuffix(matched[1], matched[2])
  matched = source.match(/^共\s*(.+?)\s*条$/)
  if (matched) return handlers.totalRows(matched[1])
  matched = source.match(/^(.+?)\s*篇常见问题\s*·\s*(.+)$/)
  if (matched) return handlers.faqSummary(matched[1], matched[2])

  let replaced = source
  let replacedUnits = false
  replaced = replaced.replace(/([\d,.]+|--)\s*台/g, (_, value) => {
    replacedUnits = true
    return handlers.bots(value)
  })
  replaced = replaced.replace(/([\d,.]+|--)\s*单/g, (_, value) => {
    replacedUnits = true
    return handlers.orders(value)
  })
  if (replacedUnits) return replaced

  matched = source.match(/^(.+)\s*台$/)
  if (matched) return handlers.bots(matched[1])
  matched = source.match(/^(.+)\s*单$/)
  if (matched) return handlers.orders(matched[1])
  matched = source.match(/^(.+)\s*个策略$/)
  if (matched) return handlers.strategies(matched[1])
  matched = source.match(/^共\s*(\d+)\s*条记录$/)
  if (matched) return handlers.records(matched[1])
  matched = source.match(/^(\d+)\s*条未读$/)
  if (matched) return handlers.unread(matched[1])
  matched = source.match(/^(\d+)\s*年\s*(\d{1,2})\s*月$/)
  if (matched) return handlers.yearMonth(matched[1], matched[2])
  matched = source.match(/^(\d+)\s*年$/)
  if (matched) return handlers.year(matched[1])
  matched = source.match(/^(\d{1,2})\s*月$/)
  if (matched) return handlers.month(matched[1])
  matched = source.match(/^共\s*(\d+)\s*条记录\s*·\s*第\s*(\d+)\s*\/\s*(\d+)\s*页$/)
  if (matched) return handlers.pageSummary(matched[1], matched[2], matched[3])
  matched = source.match(/^(\d+)\s*\/\s*(\d+)\s*已绑定$/)
  if (matched) return handlers.bound(matched[1], matched[2])
  return ''
}

export function translateText(value, locale = localeState.current) {
  if (typeof value !== 'string') return value
  const normalizedLocale = normalizeLanguage(locale)
  if (normalizedLocale === 'zh-CN') return value
  const source = value.trim()
  if (!source) return value
  const localeMessages = pcMessages[normalizedLocale] || {}
  const localeOverrides = PC_OVERRIDES[normalizedLocale] || {}
  if (Object.prototype.hasOwnProperty.call(localeMessages, source)) {
    return preserveWhitespace(value, localeMessages[source])
  }
  if (Object.prototype.hasOwnProperty.call(localeOverrides, source)) {
    return preserveWhitespace(value, localeOverrides[source])
  }
  const catalogKey = sourceIndex[source]
  const translated = catalogKey && targetCatalogs[normalizedLocale]
    ? targetCatalogs[normalizedLocale][catalogKey]
    : ''
  if (translated) {
    return preserveWhitespace(
      value,
      normalizedLocale === 'zh-HK' ? toHongKongTraditional(translated) : translated
    )
  }
  const dynamicTranslation = translateDynamic(source, normalizedLocale)
  if (dynamicTranslation) {
    if (normalizedLocale === 'zh-HK') {
      return preserveWhitespace(value, toHongKongTraditional(dynamicTranslation))
    }
    const completedDynamicTranslation = translateByFragments(dynamicTranslation, normalizedLocale)
    return preserveWhitespace(value, completedDynamicTranslation || dynamicTranslation)
  }
  const fragmentTranslation = normalizedLocale === 'zh-HK'
    ? ''
    : translateByFragments(source, normalizedLocale)
  if (fragmentTranslation) return preserveWhitespace(value, fragmentTranslation)
  if (normalizedLocale === 'zh-HK') return preserveWhitespace(value, toHongKongTraditional(source))
  return value
}

const localizedAttributes = new WeakMap()
const localizedInstances = new Set()
const ATTRIBUTE_NAMES = ['placeholder', 'title', 'aria-label', 'alt']

function localizeAttribute(element, name) {
  if (!element.hasAttribute(name)) return
  let sourceMap = localizedAttributes.get(element)
  if (!sourceMap) {
    sourceMap = {}
    localizedAttributes.set(element, sourceMap)
  }
  const current = element.getAttribute(name) || ''
  let state = sourceMap[name]
  if (!state) {
    state = { source: current, translated: current }
    sourceMap[name] = state
  } else if (current !== state.source && current !== state.translated) {
    state.source = current
  }
  const translated = translateText(state.source)
  if (current !== translated) element.setAttribute(name, translated)
  state.translated = translated
}

export function localizeElement(root) {
  if (!root || root.nodeType !== 1) return
  const elements = [root].concat(Array.from(root.querySelectorAll('*')))
  elements.forEach(element => ATTRIBUTE_NAMES.forEach(name => localizeAttribute(element, name)))
}

function updateDocumentLocale(locale) {
  if (typeof document === 'undefined') return
  document.documentElement.lang = locale
  const title = translateText('UPlus AI 量化交易平台', locale)
  document.title = title
  const description = document.querySelector('meta[name="description"]')
  if (description) description.setAttribute('content', title)
}

function localizeMessagePayload(payload) {
  if (typeof payload === 'string') return translateText(payload, localeState.current)
  if (!payload || typeof payload !== 'object') return payload
  return Object.assign({}, payload, {
    message: typeof payload.message === 'string'
      ? translateText(payload.message, localeState.current)
      : payload.message
  })
}

function installElementMessageI18n() {
  const message = Vue.prototype.$message
  if (typeof message !== 'function' || message.__uplusLocalized) return
  const localizedMessage = payload => message(localizeMessagePayload(payload))
  ;['success', 'warning', 'info', 'error'].forEach(type => {
    localizedMessage[type] = payload => message[type](localizeMessagePayload(payload))
  })
  if (typeof message.closeAll === 'function') {
    localizedMessage.closeAll = () => message.closeAll()
  }
  localizedMessage.__uplusLocalized = true
  Vue.prototype.$message = localizedMessage
}

export function installI18n() {
  const createTextVNode = Vue.prototype._v
  const stringify = Vue.prototype._s

  Vue.prototype.$t = function translate(key, fallback = '') {
    // Reading the observable value registers the active render watcher.
    const locale = localeState.current
    return translateText(fallback || key, locale)
  }

  Vue.prototype.$tk = function translateCatalogKey(key) {
    const locale = localeState.current
    return translateKey(key, locale)
  }

  Vue.prototype._v = function localizedTextVNode(value) {
    return createTextVNode.call(this, translateText(value, localeState.current))
  }

  Vue.prototype._s = function localizedString(value) {
    const output = stringify.call(this, value)
    return typeof output === 'string' ? translateText(output, localeState.current) : output
  }

  installElementMessageI18n()

  Vue.mixin({
    beforeCreate() {
      localizedInstances.add(this)
    },
    mounted() {
      this.$nextTick(() => localizeElement(this.$el))
    },
    updated() {
      localizeElement(this.$el)
    },
    beforeDestroy() {
      localizedInstances.delete(this)
    }
  })

  if (typeof window !== 'undefined') {
    updateDocumentLocale(localeState.current)
    window.addEventListener('uplus-language-change', event => {
      const nextLocale = normalizeLanguage(event && event.detail)
      // Vue 2 caches static render trees. Clear them before changing locale so
      // hard-coded template text is regenerated instead of keeping the old language.
      localizedInstances.forEach(instance => {
        instance._staticTrees = null
      })
      localeState.current = nextLocale
      updateDocumentLocale(localeState.current)
      localizedInstances.forEach(instance => {
        if (!instance._isDestroyed) instance.$forceUpdate()
      })
      Vue.nextTick(() => localizeElement(document.body))
    })
  }
}
